import React from 'react';
import { useMediaQuery } from 'react-responsive';
import Desktop from './Desktop';
import Mobile from './Mobile';

export default function ViewRenderer(props) {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

